/* eslint-disable react/destructuring-assignment */
import React from "react"

export default (text: string): JSX.Element => {
  const highlighted = window.location.pathname.startsWith(
    `/${text}`.split(" ").join("-").toLowerCase()
  )
  return (
    <li key={text} className="legal-sidenav-list-header">
      <div
        className={`legal-sidenav-option legal-sidenav-option--${
          highlighted ? "colorA" : "colorB"
        }`}
      >
        {text.split("/").pop()}
      </div>
    </li>
  )
}
